import { useState } from "react";
import { apiAdmin, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";

function RenameForm({ tv, onClose, onSaved }) {
  const [name, setName] = useState(tv.name || "");
  const [location, setLocation] = useState(tv.location || "");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) { toast.error("El nombre no puede estar vacío"); return; }
    setSaving(true);
    try {
      await apiAdmin.patch(`/tvs/${tv.id}`, { name: name.trim(), location: location.trim() });
      toast.success(`Pantalla renombrada a “${name.trim()}”`);
      onSaved();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <Label className="text-xs">Nombre de la pantalla *</Label>
        <Input value={name} onChange={(e) => setName(e.target.value)} autoFocus className="mt-1" placeholder="ej. TV Barra principal" data-testid="rename-tv-name-input" />
      </div>
      <div>
        <Label className="text-xs">Ubicación</Label>
        <Input value={location} onChange={(e) => setLocation(e.target.value)} className="mt-1" placeholder="ej. Detrás del mostrador" data-testid="rename-tv-location-input" />
      </div>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onClose} disabled={saving} data-testid="rename-tv-cancel">Cancelar</Button>
        <Button type="submit" disabled={saving} data-testid="rename-tv-submit">{saving ? "Guardando…" : "Guardar"}</Button>
      </DialogFooter>
    </form>
  );
}

export default function RenameTVDialog({ tv, onClose, onSaved }) {
  return (
    <Dialog open={!!tv} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="rename-tv-dialog">
        <DialogHeader>
          <DialogTitle>Editar pantalla</DialogTitle>
          <DialogDescription className="text-xs text-slate-500">
            Cambia el nombre y la ubicación. El Fire Stick sigue conectado con su mismo contenido.
          </DialogDescription>
        </DialogHeader>
        {tv && <RenameForm key={tv.id} tv={tv} onClose={onClose} onSaved={onSaved} />}
      </DialogContent>
    </Dialog>
  );
}
